import './quotes';
import './projects';
import './faqs';
import './jquery.validate_en';
